import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
Vue.use(VueI18n);
//引入各个语言配置文件
import { zh_cn_Language } from "./package/zh-cn";
import { ru_Language } from "./package/ru";
import { en_Language } from './package/en';
import { Loading, MessageBox } from 'element-ui';
//ElementUI语言包
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import enLocale from 'element-ui/lib/locale/lang/en';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';

//创建专用于翻译加载的axios实例（3分钟超时，避免海外服务器超时问题）
const i18nRequest = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60*3*1000 // 3分钟
});

let i18n, LangVersion = 'v1.0.0';   //版本号，数据需要强制更新时，可更新版本号
//检查当前是否存在国际化缓存
let LangCache = localStorage.getItem('_LanguageCache'),
    LangLocale = localStorage.getItem('_SystemLanguage');

if(LangCache) {
  LangCache = JSON.parse(LangCache);
  //验证当前缓存有效性（验证时间和版本）
  LangCache.cache && LangCache.expire > Date.now() && LangCache.version === LangVersion ?
    //依据缓存设置语言包
    initSetLangPack(LangCache.data) :
      //重新读取后端语言包
      initLoadLangPack();
}
else {
  //检查是否有"跳过"标记（用户主动跳过翻译加载）
  const skipCache = localStorage.getItem('_SkipLanguageCache');
  if(skipCache) {
    //用户之前跳过了，直接使用默认中文
    initSetLangPack([]);
  } else {
    //动态读取后端语言包
    initLoadLangPack();
  }
}

//初始化加载语言包
function initLoadLangPack() {
  const loading = Loading.service({
    lock: true, text: '数据初始化中，请稍候...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
  });
  
  //动态读取后端的翻译数据（使用独立axios实例，3分钟超时）
  i18nRequest({
    url: '/languageTranslations/listAllLanguageTranslations',
    method: 'get',
  }).then(response => {
    const data = response.data;
    //转换国际化的数据
    if(data.code === 200) {
      const langData = data.data;
      //写入当前国际化校验数据
      localStorage.setItem('_LanguageCache', JSON.stringify({
        cache: true, version: LangVersion, expire: Date.now() + 60000 * 60 * 24 * 30,  //缓存时间30天
        data: langData
      }));

      //以当前数据设置语言包
      initSetLangPack(langData);

      loading.close();
      //等待语言包完成加载后，刷新页面使语言包生效
      window.location.reload();
    } else {
      loading.close();
      showLoadError('翻译数据加载失败，可能是网络不稳定或服务器响应慢。');
    }
  }).catch(error => {
    loading.close();
    
    //详细的错误诊断
    console.error('===== 翻译数据加载失败详情 =====');
    console.error('错误对象:', error);
    console.error('错误消息:', error.message);
    console.error('错误代码:', error.code);
    console.error('响应数据:', error.response && error.response.data);
    console.error('响应状态:', error.response && error.response.status);
    console.error('响应头:', error.response && error.response.headers);
    console.error('请求配置:', error.config);
    console.error('================================');
    
    //根据错误类型显示不同的提示
    let errorMsg = '翻译数据加载失败，可能是网络不稳定或服务器响应慢。';
    
    if(error.code === 'ECONNABORTED') {
      errorMsg = '翻译数据加载超时（超过3分钟），请检查网络或稍后重试。';
    } else if(error.response && error.response.status === 500) {
      errorMsg = '服务器内部错误（500），翻译接口异常，请联系技术人员或选择跳过。';
    } else if(error.response && error.response.status === 504) {
      errorMsg = '服务器网关超时（504），请稍后重试。';
    } else if(error.response && error.response.status === 502) {
      errorMsg = '服务器错误（502），请稍后重试。';
    } else if(error.response && error.response.status === 404) {
      errorMsg = '翻译接口不存在（404），请联系技术人员。';
    } else if(error.message === 'Network Error') {
      errorMsg = '网络连接失败，请检查网络后重试。';
    }
    
    showLoadError(errorMsg);
  });
}

//显示加载错误对话框
function showLoadError(errorMsg) {
  //先确保i18n实例已初始化（避免MessageBox渲染时找不到$t方法）
  if(!i18n) {
    initSetLangPack([]);
  }
  
  MessageBox.confirm(
    errorMsg + '您可以选择重试或跳过（将使用中文）。',
    '加载失败',
    {
      confirmButtonText: '重试',
      cancelButtonText: '跳过（使用中文）',
      type: 'warning',
      closeOnClickModal: false,
      closeOnPressEscape: false
    }
  ).then(() => {
    //用户点击"重试"
    initLoadLangPack();
  }).catch(() => {
    //用户点击"跳过"，使用默认中文
    const loading = Loading.service({
      lock: true, text: '正在切换到中文，请稍候...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
    });
    
    //初始化语言包（使用空数据，仅使用本地默认中文）
    initSetLangPack([]);
    
    //设置语言为中文
    localStorage.setItem('_SystemLanguage', 'zh-cn');
    
    //保存"跳过"标记，避免下次刷新时重新加载
    localStorage.setItem('_SkipLanguageCache', 'true');
    
    //刷新页面使i18n实例生效
    setTimeout(() => {
      loading.close();
      window.location.reload();
    }, 500);
  });
}
//初始化设置语言包
function initSetLangPack(data) {
  //整合英文与俄文数据
  let enData = {}, ruData = {};
  data.forEach(d => {
    d.english && (enData[d.chinese] = d.english);
    d.russian && (ruData[d.chinese] = d.russian);
  });

  //移除当前语言包
  //this.$i18n.setLocaleMessage('en', {});
  //this.$i18n.setLocaleMessage('ru', {});
  //初始化写入语言包数据（按需写入）
  //this.$i18n.locale === 'en' && this.$i18n.setLocaleMessage('en', enData);
  //this.$i18n.locale === 'ru' && this.$i18n.setLocaleMessage('ru', ruData);

  //按需加载时切换语言需重载语言包，翻译无性能瓶颈时仅加载一次语言包即可
  //i18n.setLocaleMessage('en', enData);
  //i18n.setLocaleMessage('ru', ruData);

  /**
   * 待数据加载完成，再进行i18n实例的初始化
   * 确保missing加载时能读取到当前最新的语言包信息
   */
  //创建vue-i18n实例i18n
  i18n = new VueI18n({
    //设置默认语言
    locale: LangLocale || 'zh-cn',   //语言标识，页面对应显示相同的语言
    fallbackLocale: 'zh-cn', //设置回退语言，避免在没有翻译时尝试查找其他语言
    //添加多语言（每一个语言标示对应一个语言文件）
    messages: {
      //简体中文
      'zh-cn': {
        ... zhLocale, ... zh_cn_Language,
      },
      //俄语
      'ru': {
        ... ruData, ... ruLocale, ... ru_Language,   //读取附加语言包，靠后语言包优先级更高，可用于自定义
      },
      //英语
      'en': {
        ... enData, ... enLocale, ... en_Language,
      }
    },
    //缺少本地化时的处理函数
    missing(locale, key, vm, values) {

      //写入/读取当前语言包数据
      let cacheLang = locale === 'ru' ? ruData : locale === 'en' ? enData : null;
      if(!cacheLang) return;

      //转换文本数据，使其能往下检索，到这一步说明完全匹配的数据不存在
      let result = '', newKey = key.replace(/\s/g, '');  //去除空格
      //提取数据，将中文与非中文字段分割
      newKey = newKey.match(/[\u4e00-\u9fa5]+|[^\u4e00-\u9fa5]+/g);
      newKey.forEach(tempKey => {
        result += (cacheLang[tempKey] || ' ' + tempKey + ' ')   //原key输出时增加空格间距，防止英文和俄文贴合在一起
      });

      //输出匹配后的整合值，不存在则输出原Key
      return result || key;
    },
  });
}

export default i18n;



// WEBPACK FOOTER //
// ./src/language/i18n.js